import React from 'react';
import { Space } from 'antd';
import WorkspaceSection from './sections/Workspace';
import AdministrationSection from './sections/Administration';
const NavigationSections = () => (<Space size={32} direction='vertical'>
    <WorkspaceSection />
    <AdministrationSection />
  </Space>);
export default NavigationSections;
